import MoreTitle from '@/components/common/MoreTitle.vue'

import Popup from '@/components/common/Popup.vue'

import RkTable from '@/components/common/sticky-table/table.vue'
import RkTableColumn from '@/components/common/sticky-table/table-column.vue'

import ColTable from '@/components/common/column-table/table.vue'
import ColTableColumn from '@/components/common/column-table/column.vue'

import RkSelect from '@/components/common/RkSelect.vue'

import NoDataFriendly from '@/components/common/NoDataFriendly.vue'

export default (Vue) => {
  Vue.component('MoreTitle', MoreTitle)
  Vue.component('Popup', Popup)
  Vue.component('RkTable', RkTable)
  Vue.component('RkTableColumn', RkTableColumn)
  Vue.component('ColTable', ColTable)
  Vue.component('ColTableColumn', ColTableColumn)
  Vue.component('RkSelect', RkSelect)
  Vue.component('NoDataFriendly', NoDataFriendly)
}
